function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { sdkLogger } from '../../../logger';
export function mapNonLinearAdDataToEvent(adData, pixelFetch) {
    var wasConsumed = false;
    return {
        consume: function() {
            if (wasConsumed) {
                throw new Error('cannot call consume on the same event twice');
            }
            wasConsumed = true;
            if (!adData) {
                return null;
            }
            var wasStarted = false;
            var wasEnded = false;
            var nonLinearAd = {
                variants: _to_consumable_array(adData.variants),
                shown: function() {
                    if (wasStarted) {
                        sdkLogger.warn('cannot call shown on the same ad twice');
                        return;
                    }
                    wasStarted = true;
                    adData.adStartedBeacons.forEach(function(b) {
                        return pixelFetch.fetch(b);
                    });
                },
                ended: function() {
                    if (!wasStarted) {
                        // no logging as this is an expected execution path
                        return;
                    }
                    if (wasEnded) {
                        sdkLogger.warn('cannot dismiss the same ad twice');
                        return;
                    }
                    wasEnded = true;
                    adData.adFinishedBeacons.forEach(function(b) {
                        return pixelFetch.fetch(b);
                    });
                }
            };
            if (adData.variants.length === 0) {
                // special case: beacons for empty ads are fired automatically
                wasStarted = true;
                adData.adStartedBeacons.forEach(function(b) {
                    return pixelFetch.fetch(b);
                });
                delete nonLinearAd.shown;
            }
            return nonLinearAd;
        }
    };
}

//# sourceMappingURL=map-non-linear-ad-data-to-event.js.map